export const en = {
  bookDemoNonprofitPage: {
    meta: { title: 'Book a Demo — Nonprofits' },
    eyebrow: 'Book a demo',
    heading_main: 'See how Purposely brings volunteers',
    heading_em: 'to your cause',
    lead: "We work with companies that run employee volunteer programs and we'd love to connect you with them. This is a quick conversation to learn about your organization and find out how we can support your work.",
    expect: [
      {
        title: '30 minutes, quick chat',
        sub: "We'll ask about your programs, your capacity, and what kinds of corporate volunteers would be a good fit for your work.",
      },
      {
        title: 'A conversation, not a pitch',
        sub: "We want to understand your mission so we can connect the right companies and volunteers to you.",
      },
      {
        title: 'Get added to the network',
        sub: "If it's a good fit, we'll add your organization to our platform.",
      },
    ],
    trust: {
      heading: 'Nonprofits already on the platform',
      logos: ['Whole Way House', 'Global Medic', 'SickKids Foundation', 'Kits for a Cause'],
    },
    cal: {
      heading: 'Pick a time that works',
      sub: "All times in your local timezone. We'll send a calendar invite immediately.",
    },
    fallback: {
      strong: 'Prefer email?',
      text: "We'll get you a time within one business day.",
      email: 'demo@purposely.co',
    },
  },
}
